import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import imgTraffic from '../img/Traffic.png';
import imgSmartship from '../img/Smartship.png';
import imgSvessel from '../img/Svessel.png';
import FAQ_Card from '../../HumanResource/Component/FAQ_Card';
// import {Button, Form, FormControl, Nav, Navbar, NavDropdown, } from "react-bootstarp";
import '../../CompanyInfo/css/JobIntroduction.css'
import arrow_D from '../../HumanResource/img/ep_arrow-down-bold.png';
import arrow_U from '../../HumanResource/img/ep_arrow-up-bold.png';
import Card from './JobIntroDuction_Card'
import Text from '../../../common/Text.js';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/bundle';
import { Mousewheel, Navigation, Pagination } from 'swiper/modules';




function JobIntroduction() {
    /*button 클릭 이벤트*/
    let data = [1, 2, 3]


    /*Button 테스트*/
    const [btnActive, setBtnActive] = useState('');

    function ShowButton() {
        const btn = btnActive === '' ? setBtnActive("Blue") : setBtnActive("Black")
        setBtnActive(btn);
    }

    /*Tab 전환 이벤트*/
    const location = useLocation();
    const [activeTab, setActiveTab] = useState(1);
    console.log(activeTab);
    /*Tab 테두리 색상 변경 이벤트*/
    const [buttonBorders, setButtonBorders] = useState({ button1: true, button2: false, button3: false });

    const handleClick = (buttonName, tabIndex) => {
        // setButtonBorders((prevBorders) => ({
        //   ...prevBorders,
        //   [buttonName]:!prevBorders[buttonName],
        // }));
        setButtonBorders({
            button1: false,
            button2: false,
            button3: false,
            button4: false,
            button5: false,
            [buttonName]: true,
        })

        setActiveTab(tabIndex);
    };

    // const handleBorderClick = (tabIndex) => {
    //     setButtonBorders((prevBorders) => ({
    //         ...prevBorders,
    //         [tabIndex]: !prevBorders[tabIndex],
    //       }));
    // }

    //박스 펼치고 접기 이벤트를 위해 내용을 객체화한다.
    const develop = [
        {
            group: "CAD개발",
            summary: "설계 작업의 자동화를 구현하고 In-house 도구를 개발하여 설계 효율성을 높입니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>CAD 자동화 솔루션 개발 <br />
                        In-house 설계 도구 및 소프트웨어 개발
                    </div>
                </div>
            ),
            id: 1
        },
        {
            group: "ICT개발",
            summary: "설계와 생산 공정을 지원하는 시스템을 개발하며, 디지털 기술을 통해 효율성을 높입니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        설계 및 생산 지원 시스템 개발 <br />
                        데이터 통합과 관리 솔루션 제공
                    </div>
                </div>
            ),
            id: 2

        },
        {
            group: "기술개발",
            summary: "조선산업 전반에서 필요한 최신 기술을 연구하고 개발하여 회사의 경쟁력을 강화합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        조선산업 관련 기술 개발 및 최적화 <br />
                        설계 및 생산 공정에 대한 기술 지원
                    </div>
                </div>
            ),
            id: 3

        },
        {
            group: "DX개발",
            summary: "선박 운항 정보 플랫폼을 개발하여 조선산업의 디지털 전환을 가속화합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        운항 정보 플랫폼 개발 <br />
                        데이터 기반 서비스 제공
                    </div>
                </div>
            ),
            id: 4

        },
        {
            group: "스마트개발",
            summary: "운항 데이터를 분석 및 가공하여 고객 맞춤형 솔루션을 제공합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        운항 데이터 수집, 분석, 및 가공 <br />
                        데이터 기반 의사결정 지원
                    </div>
                </div>
            ),
            id: 5

        },
        {
            group: "DT솔루션개발",
            summary: "디지털 트윈 기술을 통해 설계, 생산, 운항 전반의 시뮬레이션과 분석을 제공합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        디지털 트윈 기반 솔루션 개발 <br />
                        설계 및 운항 시뮬레이션 시스템 구축
                    </div>
                </div>
            ),
            id: 6

        },
    ]
    const design1 = [
        {
            group: "구조생설",
            summary: "선박 제작에 필요한 기본 자료를 준비하고 상세 설계를 수행합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        강재취재 : 선박 제작에 필요한 강재의 사양을 산출 및 최적화 <br />
                        선체 공작도 : 선박 구조의 조립과 제작을 위한 도면 작성 <br />
                        선체 가공도 : 강재 절단 및 가공을 위한 도면 설계
                    </div>
                </div>
            ),
            id: 1
        },
        {
            group: "종합기술",
            summary: "건조가 완료된 선박을 선주에게 인도하는 마지막 단계까지 종합적인 기술 지원을 제공합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        Document Control : 설계 및 제작 문서의 체계적 관리 <br />
                        Commissioning 및 시운전 : 선박 시스템의 성능 확인 및 최적화 <br />
                        공수산출 및 완성도 : 생산물량관리 및 완성도 관리
                    </div>
                </div>
            ),
            id: 2
        },
        {
            group: "생산기술",
            summary: "선박의 최적화된 생산 공법을 연구하고, 안전한 생산 공정의 효율성을 담당합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        공법 개발 : 효율적인 제작 공법 설계 및 지원 <br />
                        해상운송 및 Lifting Lug : 구조물의 안전한 운송 및 리프팅 지원 <br />
                        족장설치 및 도장기술 : 작업 환경 최적화 및 품질 향상을 위한 도장 기술 지원
                    </div>
                </div>
            ),
            id: 3
        },
        {
            group: "구조연구",
            summary: "최신 해석 기술과 데이터를 기반으로 선박 구조의 안정성과 성능을 최적화하는 역할을 수행합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        전선/피로해석 : 선박 구조물의 피로 수명 평가 <br />
                        변형정도해석 : 구조물 변형과 응력 분석 <br />
                        배관응력해석 : 배관 시스템의 안전성 확인 <br />
                        진동/소음해석 : 선박 운항 중 진동 및 소음 최소화 <br />
                        강도해석 : 구조물의 강도 및 안정성 검증 <br />
                    </div>
                </div>
            ),
            id: 4
        }
    ]
    const design2 = [
        {
            group: "기장설계",
            summary: "선박의 기관실 구역에 설치되는 주요 장비와 배관 시스템의 배치를 설계합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        기관실 구역의 장비 및 배관 배치 설계 <br />
                        공간 효율성과 유지보수를 고려한 최적의 설계 제공
                    </div>
                </div>
            ),
            id: 1
        },
        {
            group: "철의설계",
            summary: "구조적 안정성을 더하는데 필요한 철구조물 설계를 담당합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        기관실 및 선장 구역의 철구조물 설계 <br />
                        안전성과 제작 효율성을 고려한 구조 설계
                    </div>
                </div>
            ),
            id: 2
        },
        {
            group: "선장설계",
            summary: "선박의 화물창과 관련된 장비 및 배관 배치 설계를 전문으로 합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        선장 구역의 장비와 배관 배치 설계 <br />
                        작업 효율성과 기능성을 고려한 설계 솔루션 제공
                    </div>
                </div>
            ),
            id: 3
        },
        {
            group: "전장설계",
            summary: "선박 내 전기 및 전자 장비와 제어 시스템, 전로 배치 설계를 담당합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        선박의 전기/전자 장비 배치 설계 <br />
                        제어 시스템 및 전로 설계
                    </div>
                </div>
            ),
            id: 4
        }
    ]
    const quality = [
        {
            group: "구조도장품질",
            summary: "선체 구조가 설계 도면에 따라 올바르게 설치되었는지, 그리고 실제 강도가 요구 기준을 충족하는지 검사하고 관리합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        선체 구조물의 강도 검사 및 테스트 및 도장 작업이 설계 기준과 일치 여부 검사, 구조물 제작 공정의 품질 관리 <br />
                        작업 효율성과 기능성을 고려한 설계 솔루션 제공
                    </div>
                </div>
            ),
            id: 1
        },
        {
            group: "의장품질",
            summary: "선박의 의장 부품이 올바르게 제작 및 설치되었는지 확인하여, 선박이 안전하고 효율적으로 운영될 수 있도록 지원합니다.",
            detail: (
                <div className='detaildiv'>
                    <div className='detailtitle'>주요업무<br /></div>
                    <div className='detailtext'>
                        상선에서 사용되는 의장품의 제작 및 설치 검사 및 설계 기준과 작업 완료 사항의 일치 여부 검토 <br />
                        해양 플랜트에 필요한 의장품의 품질 검사 및 해상 환경에서의 안전성을 고려한 품질 관리
                    </div>
                </div>
            ),
            id: 2
        },
    ]
    const management = [
        {
            group: '인사',
            summary: '인재 채용, 교육 및 복리후생 관리를 통해 직원의 성장과 만족을 지원합니다.',
        },
        {
            group: '재무',
            summary: '예산 수립, 재무 보고 및 위험 관리를 통해 조직의 재무 건전성을 유지합니다.',
        },
        {
            group: '안전',
            summary: '안전 정책 수립과 교육을 통해 안전한 근무 환경을 조성하고 사고를 예방합니다.',
        }
    ]
    const [index, setIndex] = useState(0);

    const developList = develop.map((value) => {


        return (<Card group={value.group}
            summary={value.summary}
            detail={value.detail}
            id={value.id}
            index={index}
            setIndex={setIndex}
        >

        </Card>);
    })

    const design1List = design1.map(value => {
        return (<Card group={value.group}
            summary={value.summary}
            detail={value.detail}
            id={value.id}
            index={index}
            setIndex={setIndex}
        >

        </Card>);
    })

    const design2List = design2.map(value => {
        return (<Card group={value.group}
            summary={value.summary}
            detail={value.detail}
            id={value.id}
            index={index}
            setIndex={setIndex}
        >

        </Card>);
    })

    const qualityList = quality.map(value => {
        return (<Card group={value.group}
            summary={value.summary}
            detail={value.detail}
            id={value.id}
            index={index}
            setIndex={setIndex}
        >

        </Card>);
    })

    const managementList = management.map(value => {
        return (<div className='borderbox1'>
            <div className='boxitem'>
                <div className='borderboxtitle'>
                    {value.group}
                </div>
                <div className='borderboxsubtitle'>
                    {value.summary}
                </div>
            </div>
        </div>
        )
    })

    return (
        <div className='JobMain'>
            <div className='JobBody1'>
                <Text variant="titlename" className='Title_Job'>직무소개</Text>
            </div>
            {/* 
            <div id='JobMain_GroupTab'>
                <button className={"btnLine2" + (activeTab == 1 ? " active" : "")} onClick={() => handleClick('button1', 1)}>스마트혁신팀</button>
                <button className={"btnLine2" + (activeTab == 2 ? " active" : "")} onClick={() => handleClick('button3', 2)}>구조설계팀</button>
                <button className={"btnLine2" + (activeTab == 3 ? " active" : "")} onClick={() => handleClick('button4', 3)}>의장설계팀</button>
                <button className={"btnLine2" + (activeTab == 4 ? " active" : "")} onClick={() => handleClick('button5', 4)}>품질경영팀</button>
                <button className={"btnLine2" + (activeTab == 5 ? " active" : "")} onClick={() => handleClick('button2', 5)}>경영지원팀</button>
            </div> */}

            <div id='JobMain_GroupTab' className='groupSwiper'>
                <div className="jobswiper-button-custom-prev" />
                <Swiper className='Jobintro_swiper'
                    modules={[Navigation, Pagination]}
                    // navigation={true} 
                    // pagination={{ clickable: true }}
                    navigation={{
                        nextEl: '.jobswiper-button-custom-next',
                        prevEl: '.jobswiper-button-custom-prev',
                    }}
                    spaceBetween={10}
                    breakpoints={{
                        0: {
                            slidesPerView: 3,
                        },
                        769: {
                            slidesPerView: 5,
                        },
                    }}
                >
                    <SwiperSlide className='swiper-slide-jobintro'>
                        <button className={"btnLine2" + (activeTab == 1 ? " active" : "")} onClick={() => handleClick('button1', 1)}>스마트혁신팀</button>
                    </SwiperSlide>
                    <SwiperSlide className='swiper-slide-jobintro'>
                        <button className={"btnLine2" + (activeTab == 2 ? " active" : "")} onClick={() => handleClick('button3', 2)}>구조설계팀</button>
                    </SwiperSlide>
                    <SwiperSlide className='swiper-slide-jobintro'>
                        <button className={"btnLine2" + (activeTab == 3 ? " active" : "")} onClick={() => handleClick('button4', 3)}>의장설계팀</button>
                    </SwiperSlide>
                    <SwiperSlide className='swiper-slide-jobintro'>
                        <button className={"btnLine2" + (activeTab == 4 ? " active" : "")} onClick={() => handleClick('button5', 4)}>품질경영팀</button>
                    </SwiperSlide>
                    <SwiperSlide className='swiper-slide-jobintro'>
                        <button className={"btnLine2" + (activeTab == 5 ? " active" : "")} onClick={() => handleClick('button2', 5)}>경영지원팀</button>
                    </SwiperSlide>

                </Swiper>

                <div className="jobswiper-button-custom-next" />
            </div>

            {activeTab === 1 && <div> {/* tab1의 내용 */}
                {developList}
            </div>}
            {activeTab === 2 && <div> {/* tab2의 내용 */}
                {design1List}
            </div>}
            {activeTab === 3 && <div> {/* tab3의 내용 */}
                {design2List}
            </div>}
            {activeTab === 4 && <div> {/* tab4의 내용 */}
                {qualityList}
            </div>}
            {activeTab === 5 && <div> {/* tab5의 내용 */}
                {managementList}
            </div>}
            
        </div>
    );
}

export default JobIntroduction;